__turbopack_context__.v({
  "boxPickupSections": "BoxPickupSections-module-scss-module__HI9ksW__boxPickupSections",
  "orderSectionRow": "BoxPickupSections-module-scss-module__HI9ksW__orderSectionRow",
  "sectionInfoText": "BoxPickupSections-module-scss-module__HI9ksW__sectionInfoText",
  "selected": "BoxPickupSections-module-scss-module__HI9ksW__selected",
  "skeleton": "BoxPickupSections-module-scss-module__HI9ksW__skeleton",
});
